module.exports = __webpack_public_path__ + "img/sun-dark.526c6822.png";